export const TRACKING_ALL_ORDERS_FEE_USD = 0.05;
export const TRACKING_BILLING_TERMS_VERSION = 1;

type StoreFeatures = Record<string, any> | null | undefined;

const asObject = (value: unknown): Record<string, any> =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, any>)
    : {};

export const isAllOrdersTrackingEnabled = (features: StoreFeatures) => {
  const trackingBilling = asObject(features?.trackingBilling);

  // Keep this aligned with the backend eligibility contract. A changed fee or
  // terms version requires explicit re-acceptance unless both apps add a
  // coordinated grandfathering policy.
  return (
    features?.enableTracking === true &&
    trackingBilling.allOrdersEnabled === true &&
    Number(trackingBilling.feePerOrderUsd) === TRACKING_ALL_ORDERS_FEE_USD &&
    Number(trackingBilling.termsVersion) === TRACKING_BILLING_TERMS_VERSION &&
    Number.isFinite(Date.parse(String(trackingBilling.acceptedAt ?? '')))
  );
};
